export default "__VITE_ASSET__04Uaj2Y0__"